var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14685 19.3233C6.63944 19.7801 6.35662 20 5.94903 20C5.36676 20 5.04235 19.5771 5.04235 18.9258V16.7267H3.80974C1.33091 16.7267 0 15.3395 0 12.8528V3.87385C0 1.38714 1.33091 0 3.80974 0H16.1903C18.6691 0 20 1.3956 20 3.87385V12.8528C20 15.3311 18.6691 16.7267 16.1903 16.7267H10.0166L7.14685 19.3233ZM6.29008 15.9993V18.4522L8.95191 15.7624C9.268 15.4326 9.50091 15.3649 9.96673 15.3649H16.1903C17.8622 15.3649 18.6608 14.4937 18.6608 12.8444V3.87385C18.6608 2.2245 17.8622 1.36177 16.1903 1.36177H3.80974C2.12946 1.36177 1.33923 2.2245 1.33923 3.87385V12.8444C1.33923 14.4937 2.12946 15.3649 3.80974 15.3649H5.66621C6.1154 15.3649 6.29008 15.5425 6.29008 15.9993ZM9.36165 8.76977C9.37724 9.25073 9.77165 9.63256 10.2529 9.63256C10.7341 9.63256 11.1285 9.25073 11.1441 8.76977L11.2596 5.20658C11.278 4.63778 10.822 4.16667 10.2529 4.16667C9.68377 4.16667 9.22768 4.63778 9.24612 5.20658L9.36165 8.76977ZM9.16667 11.4698C9.16667 12.0478 9.65259 12.5 10.2529 12.5C10.8474 12.5 11.3333 12.0478 11.3333 11.4698C11.3333 10.8974 10.8474 10.4453 10.2529 10.4453C9.65259 10.4453 9.16667 10.8974 9.16667 11.4698Z",
    fill: "#FD5862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1174ed387c8304a21b3eccb40b596d5c.svg";
export { ForwardRef as ReactComponent };